module.exports = __webpack_public_path__ + "static/media/998484.2d5bd093.png";